import H2SLogo from "../../assets/img/hotel2sejour_logo.png";
import { getAgencyLogoURL } from "../../utils/S3Helper";

export type LogoProps = {
  path?: string;
}

export const Logo = (props: LogoProps) => {
  return (
    <img
      className="logo-img"
      src={props.path ? getAgencyLogoURL(`${props.path}.jpg`) : H2SLogo}
      width={"40px"}
      style={{ maxWidth: "100vw" }}
      alt="logo"
    />
  );
};
